// REA-CI/screens/VerificationResultScreen.tsx

import React from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Alert,
} from "react-native";
import { useNavigation } from "@react-navigation/native";
import { RootStackParamList, StackNavigationProp } from "../navigation/types";

type VerificationResultScreenNavigationProp = StackNavigationProp<
  RootStackParamList,
  "VerificationResultScreen"
>;

const VerificationResultScreen = () => {
  const navigation = useNavigation<VerificationResultScreenNavigationProp>();

  const handleGoToSellerHome = () => {
    navigation.navigate("SellerHomeScreen");
  };

  const handleRetryVerification = () => {
    Alert.alert(
      "Retry Verification",
      "You can go back and re-upload your ID or passport for verification."
    );
    navigation.navigate("VerificationScreen");
  };

  // Simulate an approval status for demonstration
  const isApproved = true; // This value should be dynamic based on real verification data

  return (
    <View style={styles.container}>
      <Text style={styles.title}>
        {isApproved ? "Verification Approved" : "Verification Denied"}
      </Text>
      <Text style={styles.message}>
        {isApproved
          ? "Congratulations! Your ID verification has been approved. You can now start posting properties."
          : "Unfortunately, your verification did not pass. Please try again or contact support if you believe this is an error."}
      </Text>
      {isApproved ? (
        <TouchableOpacity style={styles.successButton} onPress={handleGoToSellerHome}>
          <Text style={styles.buttonText}>Go to Seller Dashboard</Text>
        </TouchableOpacity>
      ) : (
        <TouchableOpacity style={styles.retryButton} onPress={handleRetryVerification}>
          <Text style={styles.buttonText}>Retry Verification</Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#ffffff",
    padding: 20,
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: 20,
    textAlign: "center",
    color: "#333333",
  },
  message: {
    fontSize: 16,
    marginBottom: 20,
    textAlign: "center",
    color: "#666666",
  },
  successButton: {
    backgroundColor: "#28a745",
    paddingVertical: 15,
    paddingHorizontal: 30,
    borderRadius: 5,
    marginTop: 20,
  },
  retryButton: {
    backgroundColor: "#dc3545",
    paddingVertical: 15,
    paddingHorizontal: 30,
    borderRadius: 5,
    marginTop: 20,
  },
  buttonText: {
    color: "#ffffff",
    fontSize: 16,
    fontWeight: "bold",
    textAlign: "center",
  },
});

export default VerificationResultScreen;
